import { render } from "./Dishes.vue?vue&type=template&id=33d015e0&scoped=true"
import script from "./Dishes.vue?vue&type=script&lang=js"
export * from "./Dishes.vue?vue&type=script&lang=js"

import "./Dishes.vue?vue&type=style&index=0&id=33d015e0&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d015e0"]])

export default __exports__